module.exports = __webpack_public_path__ + "static/media/bg-main.8886c545.png";